<template>
<panel>
  <p slot="header">
    {{ item.name }} <span class="gray">(grupa)</span>
  </p>
  <p slot="actions">
    <ui-button type="flat" color="primary" icon="navigate_before" @click="$router.push({name: 'admin.email-groups.show', params: {id: item.id}})">Anuluj</ui-button>
  </p>
  <email-groups-form :item="item" v-if="item.id"></email-groups-form>
</panel>

</template>
<script>
import EmailGroups from './../../services/EmailGroups'
import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Notify],
  data () {
    return {
      item: EmailGroups.getBaseItem()
    }
  },
  mounted () {
    const id = this.$route.params.id
    this.getItem(id)
  },
  methods: {
    cancel () {
      this.$router.push({name: 'admin.email-groups.dashboard', params: {id: this.item.id}})
    },
    getItem (id) {
      this.setLoading(true)
      EmailGroups.get(id).then((res) => {
        const item = EmailGroups.convertNulls(res.data.item)
        this.item = item
        this.setLoading(false)
      })
    }
  }
}

</script>


// WEBPACK FOOTER //
// Edit.vue?3b7938ee